export const education = {
  heading: 'Education',
  education: [
    {
      image:
        'https://raw.githubusercontent.com/Varun-garg/GBU_Timetables/master/app/src/main/res/drawable-xhdpi/logo.png',
      name: 'Gautam Buddha University, Greater Noida, India',
      degree: 'Integrated B.Tech + M.Tech (CSE) - 2015-20',
      description:
        'I have done my post graduation from Gautam Buddha University. I have completed my thesis under the mentorship of Dr. Pradeep Tomar. Topic of my thesis is "AN EFFICIENT CRYPTOGRAPHY TECHNIQUE USING DIFFERENT BLOCK CIPHER MODES OF OPERATION TO SECURE IoT DATA".',
    },
  ],
};
